// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`

vec4 texelMetalness;
if (tpmData.useTpmMetalnessMap){
 	texelMetalness = triplanar_mapping( metalnessMap, inverseTransformDirection( normalize( vNormal ), viewMatrix ), vWorldPosition, metalnessTpmScale );
 	metalnessFactor *= texelMetalness.b;
	// debugColor = vec4(1.0, 0.0, 1.0, 1.0);
} else {
	texelMetalness = texture2D( metalnessMap, metalnessMapUv );	
	// reads channel B, compatible with a combined OcclusionRoughnessMetallic (RGB) texture
	metalnessFactor *= texelMetalness.b ;
}

`;